import { render, staticRenderFns } from "./SoftFairOffersListElement.vue?vue&type=template&id=2b3ac753&"
import script from "./SoftFairOffersListElement.vue?vue&type=script&lang=js&"
export * from "./SoftFairOffersListElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports